import { useQuery } from '@tanstack/react-query';
import { getConfigChainsAll } from '../api';

const useChainConfig = () => {
  return useQuery({
    queryKey: ['getConfigChainsAll'],
    queryFn: getConfigChainsAll,
  });
};

export default useChainConfig;
